/**
 * formats a number according to locale
 * @param {Number} number
 * @param {Number} number
 * @returns {String} formatted number
 */
const EURO_SYMBOL = '€';
export function formatNumber(value, language, decimals) {
    let fixedRange = 0;
    if (value % 1 !== 0) {
        fixedRange = decimals || 2;
    }
    if (language === 'en') {
        return preFormat(value, fixedRange, 3, ',', '.');
    }
    return preFormat(value, fixedRange, 3, '.', ',');
}
export function formatNumberForCurrency(value, language, decimals) {
    const fixedRange = decimals || 2;
    if (language === 'en') {
        return preFormat(value, fixedRange, 3, ',', '.');
    }
    return preFormat(value, fixedRange, 3, '.', ',');
}
/**
 * formats a number according to locale with euro symbol
 * @param {Number} value
 * @returns {String} formatted number with euro symbol
 */
export function formatNumberWithCurrency(value, language) {
    const formattedNumber = formatNumber(value, language);
    if (language === 'en') {
        return EURO_SYMBOL + formattedNumber;
    }
    return EURO_SYMBOL + ' ' + formattedNumber;
}
/**
 * Number.prototype.formatInternet(n, x, s, c)
 *
 * @param value: number to formatInternet
 * @param n: length of decimal
 * @param x: length of whole part
 * @param s: sections delimiter
 * @param c: decimal delimiter
 */
function preFormat(value, n, x, s, c) {
    const regexp = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
    const fixedNumber = typeof value !== 'string' ? value.toFixed(Math.max(0, n)) : value;
    return (c ? fixedNumber.replace('.', c) : fixedNumber).replace(new RegExp(regexp, 'g'), '$&' + (s || ','));
}
